function $6320a066799d0be8$export$2e2bcd8739ae039() {
    const toggleSwitch = document.querySelector("#toggle");
    const rootElement = document.documentElement;
    toggleSwitch.addEventListener("change", handleToggleChange);
    function handleToggleChange() {
        if (rootElement.getAttribute("data-theme") === "dark") {
            rootElement.removeAttribute("data-theme");
            localStorage.removeItem("theme");
        } else {
            rootElement.setAttribute("data-theme", "dark");
            localStorage.setItem("theme", "dark");
        }
    }
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme === "dark") {
        rootElement.setAttribute("data-theme", "dark");
        toggleSwitch.checked = true;
    }
}
$6320a066799d0be8$export$2e2bcd8739ae039();


//# sourceMappingURL=index.67e4c1f8.js.map
